var React = require('react');

function Cursor (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M124 123.8c-2.4 2.4-3 3.9-3 7.2 0 6.5 99.9 253.4 104.1 257.3 2.3 2.1 3.9 2.7 7.4 2.7 8.7 0 7.9 2.1 25.4-61l15.6-56.5 56.5-15.6c63.4-17.6 61-16.6 61-25.8 0-3.9-.5-5.2-2.7-7.3-4.1-3.9-248.9-102.9-256-103.5-4.8-.5-5.5-.3-8.3 2.5zm121 65.9c47 19 88.8 35.9 92.9 37.6l7.4 3-40.4 11.2c-48.6 13.4-47.6 13.1-49.4 15.9-.8 1.2-6.8 21.5-13.3 45.1-6.6 23.5-12.1 42.1-12.4 41.4-.3-.8-15.9-39.2-34.6-85.4-18.7-46.2-36-89.1-38.5-95.2l-4.5-11.2 3.6 1.5c2.1.8 42.2 17.1 89.2 36.1z"}));
}

Cursor.defaultProps = {"version":"1.0","width":"682.667","height":"682.667","viewBox":"0 0 512 512"};

module.exports = Cursor;

Cursor.default = Cursor;
